<template>
  <div>
    <work-types
      v-if="step === 'lead-types' && selected !== null"
      ref="lead-types"
      :coverage="selected"
      @clean="setState"
    />
    <accreditations
      v-if="step === 'accreditations' && selected !== null"
      ref="accreditations"
      :coverage="selected"
      @back="goToTab('lead-types')"
      @next="goToTab('postcodes')"
      @clean="setState"
    />
    <postcodes
      v-if="step === 'postcodes' && selected !== null"
      ref="postcodes"
      :coverage="selected"
      @back="goToTab('accreditations')"
      @clean="setState"
    />
  </div>
</template>

<script>
import WorkTypes from "@/components/tabs/coverage/WorkTypes";
import Accreditations from "@/components/tabs/coverage/Accreditations";
import Postcodes from "@/components/tabs/coverage/Postcodes";
import {SELECTED_COVERAGE} from "@/store/coverage/mutation-types";
export default {
  name: "CoverageTabs",
  components: {Postcodes, Accreditations, WorkTypes},
  computed: {
    step: function() {
      return (this.$route.params.step) ?? 'lead-types';
    },
    selected: {
      get: function() {
        return this.$store.state.coverage.SELECTED_COVERAGE;
      },
      set: function (value) {
        this.$store.commit(SELECTED_COVERAGE, value);
      }
    }
  },
  methods: {
    goToTab(tab) {
      this.$router.push({name: 'lead-selection-&-coverage-tab', params: {step: tab}});
    },
    setState: function(value) {
      this.$emit('clean', value);
    },
    save: function() {
      this.$refs[this.step].save();
    },
    switchBasket: function() {
      this.$refs[this.step].switchBasket();
    }
  }
}
</script>

<style scoped>
</style>
